<template>
    <template v-if="!dismissed">
        <div class="rounded-xl border border-valence-grey-300 bg-white p-5 flex flex-col gap-2.5">
            <div class="flex items-center justify-between gap-2">
                <div class="flex items-center gap-3">
                    <div
                        v-if="initials"
                        class="w-8 h-8 rounded-full bg-[#E0E9FF] flex items-center justify-center details font-semibold text-valence-grey-850/70 border border-valence-grey-300"
                        translate="no">
                        {{ initials }}
                    </div>
                    <span class="body-small font-medium">{{ attendee.name }}</span>
                </div>
                <button type="button" class="p-1" aria-label="Remove attendee" data-test-id="remove-attendee-btn" @click="dismissed = true">
                    <i class="bi bi-trash text-gray-400 text-base" aria-hidden="true"></i>
                </button>
            </div>
            <input v-model="jobTitle" class="border border-valence-grey-300 rounded-lg p-2 body-small w-full" placeholder="Job Title" />
        </div>
    </template>
    <template v-else>
        <div class="flex flex-col items-center justify-between gap-2 h-full">
            <div class="grow flex items-center justify-center gap-2 rounded-xl text-valence-grey-750 border border-valence-grey-300 bg-[#FAFAFA] w-full px-2.5 py-4">
                <i class="bi bi-trash text-lg/none" aria-hidden="true"></i>{{ attendee.name }} removed
            </div>
            <BaseButton theme="tertiary" class="border w-full rounded-full body-small font-medium" @click="dismissed = false">Undo</BaseButton>
        </div>
    </template>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import type { ConnectionCalendarAttendee } from "~vue/types/connection";
import { getFirstLastInitials } from "~vue/utils/stringUtils";
import { computed } from "vue";

interface Props {
    attendee: ConnectionCalendarAttendee;
}

const props = defineProps<Props>();

const jobTitle = defineModel("title", { type: String, default: "" });
const dismissed = defineModel("dismissed", { type: Boolean, default: false });

const initials = computed(() => (props.attendee?.name ? getFirstLastInitials(props.attendee.name) : ""));
</script>
